import { render } from "./GameInfo.vue?vue&type=template&id=0bb5d65f&scoped=true"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"

import "./GameInfo.vue?vue&type=style&index=0&id=0bb5d65f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb5d65f"]])

export default __exports__